<div [ngStyle]="{ 'display' : horizonToolController.active? 'block' : 'none'}" [ngClass]="tabsService.minimizeScreenMode ? 'bottom-menu minimized' : ''">
  <div class="loading" [ngClass]="this.horizonToolController.progressService.horizonToolLoading? 'active' : ''">
    <div></div>
  </div>

  <form autocomplete="off"  id="ngHorizonToolController" [ngClass]="[this.horizonToolController.active ? 'active margin-tabs' : 'margin-tabs',  tabsService.fullScreenMode ? 'fullscreen margin-tabs' : 'margin-tabs']" name="ngHorizonToolController" #ngngHorizonToolController="ngForm" id="horizonToolForm" >
    <div class="fields__block">
      <div class="fields__block__section">
        <div class="title">
          <h4>Center Coordinates</h4>
          <span> </span>
        </div>
        <div class="input-fields">
          <div>
            <label for="">Latitude</label>
            <div class="coordenates">
              <select id="centerLatCard" name="centerLatCard" [(ngModel)]="this.horizonToolController.horizonModal.centerLatLonDms.latitude.cardinal" style="width: 12%;">
                <option value="N">N</option>
                <option value="S">S</option>
              </select>
              <input type="number" id="centerLatDeg" name="centerLatDeg" [(ngModel)]="this.horizonToolController.horizonModal.centerLatLonDms.latitude.degrees" style="width: 24%;" />
                <span>º</span>
              <input type="number" id="centerLatMin" name="centerLatMin" [(ngModel)]="this.horizonToolController.horizonModal.centerLatLonDms.latitude.minutes" style="width: 24%;" />
                <span>´</span>
              <input type="number" id="centerLatSec" name="centerLatSec" [(ngModel)]="this.horizonToolController.horizonModal.centerLatLonDms.latitude.seconds" style="width: 24%;" />
                <span>"</span>
                <br/>
              <input [(ngModel)]="this.horizonToolController.horizonModal.centerLatitude" name="centerLat" id="centerLat" type="number" style="width: 93%; margin-top: 10px;" />
                <span>"</span>
            </div>
          </div>
          <div>
            <label for="">Longitude</label>
            <div class="coordenates">
              <select id="centerLonCard" name="centerLonCard" [(ngModel)]="this.horizonToolController.horizonModal.centerLatLonDms.longitude.cardinal" style="width: 12%;">
                <option value="W">W</option>
                <option value="E">E</option>
              </select>
              <input type="number" id="centerLonDeg" name="centerLonDeg" [(ngModel)]="this.horizonToolController.horizonModal.centerLatLonDms.longitude.degrees" style="width: 24%;" />
                <span>º</span>
              <input type="number" id="centerLonMin" name="centerLonMin" [(ngModel)]="this.horizonToolController.horizonModal.centerLatLonDms.longitude.minutes" style="width: 24%;" />
                <span>´</span>
              <input type="number" id="centerLonSec" name="centerLonSec" [(ngModel)]="this.horizonToolController.horizonModal.centerLatLonDms.longitude.seconds" style="width: 24%;" />
                <span>"</span>
                <br/>
              <input type="number" id="centerLon" name="centerLon" [(ngModel)]="this.horizonToolController.horizonModal.centerLongitude" style="width: 93%; margin-top: 10px;" />
                <span>"</span>
            </div>
          </div>
        </div>
      </div>
      <div class="fields__block__section">
        <div class="title">
          <h4>Target Coordinates</h4>
          <span> </span>
        </div>
        <div class="input-fields">
          <div>
            <label for="">Latitude</label>
            <div class="coordenates">
              <select name="targetLatCard" [(ngModel)]="this.horizonToolController.horizonModal.targetLatLonDms.latitude.cardinal" style="width: 12%;" [disabled]="true">
                <option value="N">N</option>
                <option value="S">S</option>
              </select>
              <input type="number" name="targetLatDeg" [(ngModel)]="this.horizonToolController.horizonModal.targetLatLonDms.latitude.degrees" style="width: 24%;" readonly/>
                <span>º</span>
              <input type="number" name="targetLatMin" [(ngModel)]="this.horizonToolController.horizonModal.targetLatLonDms.latitude.minutes" style="width: 24%;" readonly/>
                <span>´</span>
              <input type="number" name="targetLatSec" [(ngModel)]="this.horizonToolController.horizonModal.targetLatLonDms.latitude.seconds" style="width: 24%;" readonly/>
                <span>"</span>
                <br/>
              <input [(ngModel)]="this.horizonToolController.horizonModal.targetLatitude" name="targetLat" type="number" style="width: 93%; margin-top: 10px;" readonly/>
                <span>"</span>
            </div>
          </div>
          <div>
            <label for="">Longitude</label>
            <div class="coordenates">
              <select name="targetLonCard" [(ngModel)]="this.horizonToolController.horizonModal.targetLatLonDms.longitude.cardinal" style="width: 12%;" [disabled]="true">
                <option value="W">W</option>
                <option value="E">E</option>
              </select>
              <input type="number" name="targetLonDeg" [(ngModel)]="this.horizonToolController.horizonModal.targetLatLonDms.longitude.degrees" style="width: 24%;" readonly/>
                <span>º</span>
              <input type="number" name="targetLonMin" [(ngModel)]="this.horizonToolController.horizonModal.targetLatLonDms.longitude.minutes" style="width: 24%;" readonly/>
                <span>´</span>
              <input type="number" name="targetLonSec" [(ngModel)]="this.horizonToolController.horizonModal.targetLatLonDms.longitude.seconds" style="width: 24%;" readonly/>
                <span>"</span>
                <br/>
              <input type="number" name="targetLon" [(ngModel)]="this.horizonToolController.horizonModal.targetLongitude" style="width: 93%; margin-top: 10px;" readonly/>
                <span>"</span>
            </div>
          </div>
        </div>
      </div>
      <div class="fields__block__section">
        <div class="title">
          <h4>Parameters</h4>
          <span> </span>
        </div>
        <div class="input-fields">
          <div>
            <label for="">Min Depth</label>
            <div class="coordenates">
              <input type="number" id="minDepth" name="minDepth" [(ngModel)]="this.horizonToolController.horizonModal.minDepth"  style="width: 40%;" />
              <span>[NM]</span>
              <span class="error" *ngIf="this.horizonToolController.errorMessage[0] != null">
                {{this.horizonToolController.errorMessage[0]}}
              </span>
            </div>
          </div>
          <div>
            <label for="">Max Depth</label>
            <div class="coordenates">
              <input type="number" id="maxDepth" name="maxDepth" [(ngModel)]="this.horizonToolController.horizonModal.maxDepth" style="width: 40%;" />
              <span>[NM]</span>
              <span class="error" *ngIf="this.horizonToolController.errorMessage[1] != null">
                {{this.horizonToolController.errorMessage[1]}}
              </span>
            </div>
          </div>
          <div>
            <label for="">Interval</label>
            <div class="coordenates">
              <input type="number" id="minStep" name="minStep" [(ngModel)]="this.horizonToolController.horizonModal.minStep" style="width: 40%;" />
              <span>[NM]</span>
              <span class="error" *ngIf="this.horizonToolController.errorMessage[2] != null">
                {{this.horizonToolController.errorMessage[2]}}
              </span>
            </div>
          </div>
          <div>
            <label for="">Height Above Terrain</label>
            <div class="coordenates">
              <input type="number" id="height" name="height" [(ngModel)]="this.horizonToolController.horizonModal.heigthAboveTerrain" style="width: 40%;" />
              <span>[m]</span>
              <span class="error" *ngIf="this.horizonToolController.errorMessage[3] != null">
                {{this.horizonToolController.errorMessage[3]}}
              </span>
            </div>
          </div>
          <div>
            <label for="">Terrain Elevation</label>
            <div class="coordenates">
              <input type="number" name="elevation" [(ngModel)]="this.horizonToolController.horizonModal.terrainElevation" style="width: 40%;" readonly/>
              <span>[m]</span>
            </div>
          </div>
          <div class="checkboxs" style="width: 100%;">
            <input
            type="checkbox"
            id="actualScreeningAngle"
            name="actualScreeningAngle"
            [(ngModel)]="this.horizonToolController.useScreening"
            />
            <label  for="actualScreeningAngle">Use Actual Screening Angle</label>
          </div>
        </div>
        <div class="table-fields">
          <div>
              <div class="fields__btn" style="cursor: default; padding: 10px 0;left: 60px">
                  <a class="blue" (click)="drawHorizonBtn()">Draw Horizon</a>
                  <button [ngClass]="this.horizonToolController.crossSectionEnabled == false? 'gray' : 'blue'" type="submit" [disabled]="!this.horizonToolController.crossSectionEnabled" (click)="callCrossSection();">Draw Cross Section</button>
              </div>
          </div>
        </div>
      </div>
    </div>
    <div class="fields__block">
      <div class="fields__block__section">
        <div class="title">
          <h4>Horizon View</h4>
          <span> </span>
        </div>
        <canvas id="canvas"></canvas>
      </div>
      <div class="fields__block__section">
        <div class="title">
          <h4>Graph Legend</h4>
          <span> </span>
        </div>
        <img src="/assets/img/colorbar.png" alt="Horizon Tool Legend" width="730" height="35" style="width: 100%;"  />
        <div class="flex">
          <p>
            {{this.horizonToolController.horizonModal.minDepth}}
          <p >
            {{this.horizonToolController.horizonModal.minDepth +  this.minMaxDepthDiff * 1/4}}
          </p>
          <p>
            {{this.horizonToolController.horizonModal.minDepth +  this.minMaxDepthDiff * 2/4}}
          </p>
          <p>
            {{this.horizonToolController.horizonModal.minDepth +   this.minMaxDepthDiff * 3/4}}
          </p>
          <p>
            {{this.horizonToolController.horizonModal.maxDepth}}
          </p>
          <div>Nautical Miles [NM]</div>
          <div style="text-align: left;">
            <img src="/assets/img/black-square.png" alt="Actual Screening Angle Legend" width="20" height="20"/>
            <span style="font-size: 12px; color: black;"> Blocked by an Actual Screening Angle </span>
          </div>

        </div>
      </div>
    </div>
  </form>

</div>
